(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer {
    constructor(element) {
      this.element = element;
      this.durationString = this.element.dataset.countdownDuration;
      this.storageKey = `countdown_end_time_${this.element.dataset.sectionId}`;
      this.timerSpans = {
        hours: this.element.querySelector(".hours"),
        minutes: this.element.querySelector(".minutes"),
        seconds: this.element.querySelector(".seconds"),
      };
      this.timerContainer = this.element.querySelector(".custom-announcement-bar__timer");

      if (!this.durationString.match(/^\d{2,}:\d{2}:\d{2}$/)) {
        if (this.timerContainer) {
            this.timerContainer.style.display = "none";
        }
        return;
      }

      this.endDate = this.getEndDate();
      this.updateClock();
      this.interval = setInterval(() => this.updateClock(), 1000);
    }

    getEndDate() {
      const storedEndDate = localStorage.getItem(this.storageKey);
      const now = new Date().getTime();

      if (storedEndDate && parseInt(storedEndDate) > now) {
        return parseInt(storedEndDate);
      }

      const parts = this.durationString.split(":");
      const hours = parseInt(parts[0], 10) || 0;
      const minutes = parseInt(parts[1], 10) || 0;
      const seconds = parseInt(parts[2], 10) || 0;
      const durationInMs = (hours * 3600 + minutes * 60 + seconds) * 1000;

      const newEndDate = now + durationInMs;
      localStorage.setItem(this.storageKey, newEndDate);
      return newEndDate;
    }

    updateClock() {
      const now = new Date().getTime();
      const distance = this.endDate - now;

      if (distance < 0) {
        clearInterval(this.interval);
        localStorage.removeItem(this.storageKey);
        if (this.timerContainer) {
            this.timerContainer.innerHTML = "Expirado";
        }
        return;
      }

      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.timerSpans.hours) {
          this.timerSpans.hours.textContent = String(hours).padStart(2, "0");
      }
      if (this.timerSpans.minutes) {
          this.timerSpans.minutes.textContent = String(minutes).padStart(2, "0");
      }
      if (this.timerSpans.seconds) {
          this.timerSpans.seconds.textContent = String(seconds).padStart(2, "0");
      }
    }
  }

  function initializeCountdown(container) {
    const announcementBars = container.querySelectorAll('.custom-announcement-bar[data-section-id]');
    announcementBars.forEach((bar) => {
      if (Shopify.designMode) {
        const storageKey = `countdown_end_time_${bar.dataset.sectionId}`;
        localStorage.removeItem(storageKey);
      }
      new CountdownTimer(bar);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initializeCountdown(document);
  });

  if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", (event) => {
      if (event.target.querySelector("[data-section-id]")) {
        initializeCountdown(event.target);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
    class NewsletterPopup {
        constructor(popupElement) {
            this.popup = popupElement;
            if (!this.popup) return;

            this.delay = parseInt(this.popup.dataset.delaySeconds, 10) * 1000;
            this.sectionId = this.popup.dataset.sectionId;
            this.sessionKey = `newsletter_popup_shown_${this.sectionId}`;
            this.closeButton = this.popup.querySelector('.newsletter-popup__close');
            this.overlay = this.popup.querySelector('.newsletter-popup__overlay');

            this.init();
        }

        init() {
            if (sessionStorage.getItem(this.sessionKey) && !Shopify.designMode) {
                return;
            }

            if (Shopify.designMode) {
                this.show();
            } else {
                setTimeout(() => this.show(), this.delay);
            }

            this.closeButton.addEventListener('click', () => this.hide());
            this.overlay.addEventListener('click', () => this.hide());
        }

        show() {
            this.popup.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            if (!Shopify.designMode) {
                sessionStorage.setItem(this.sessionKey, 'true');
            }
        }

        hide() {
            this.popup.style.display = 'none';
            document.body.style.overflow = '';
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const popupElement = document.querySelector('.newsletter-popup');
        if (popupElement) {
            new NewsletterPopup(popupElement);
        }
    });

    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            const popupElement = event.target.querySelector('.newsletter-popup');
            if (popupElement) {
                sessionStorage.removeItem(`newsletter_popup_shown_${popupElement.dataset.sectionId}`);
                new NewsletterPopup(popupElement);
            }
        });
    }

  } catch(e) { console.error(e); }
})();
})();
